<template>
    <div style="margin:0 -12px;">
        <HeaderMenu></HeaderMenu>
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <div style="padding:10px 0; overflow: hidden;" onclick="window.location.href = '/auth'">
                            <div class="item">
                                <svg style="height:36px;width:39px;fill:#5538EE;">
                                    <use xlink:href="/images/luna_logo.svg#luna_logo"></use>
                                </svg>
                            </div>
                            <div class="item">
                                <div class="logo" style="color: #5538EE;">Luna</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-2 text-center">
                        <a class="libere-header-menu" data-bs-toggle="offcanvas" href="#offcanvasRight"
                            aria-controls="offcanvasRight" style="outline: none">
                            <div class="" style="color:#5538EE;padding-top:7px;">
                                <svg style="height:25px;width:25px;fill:#5538EE;">
                                    <use xlink:href="/images/menu.svg#menu"></use>
                                </svg>
                                <div class="text-nowrap" style="font-size: 8px;">
                                    メニュー
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" style="padding-top:56px;">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div style="padding:0 17px;">
                            <br>
                            <div style="font-weight: 600;font-size: 20px;line-height: 30px;">
                                Lunaに出会って人生が大きく変わりました！
                            </div>
                            <div style="color:#777;font-size:10px;border-bottom:1px solid #e6e6e6;padding:10px 0;">
                                2023年3月28日
                            </div>
                            <br>
                            <img src="/images/Group13342.png" class="img-fluid">
                            <div class="text-center"
                                style="color:#777;font-size:10px;border-bottom:1px solid #e6e6e6;padding:15px 0;">
                                ユリさん・女性20代 M 関東<br />
                                マサさん・男性40代 S 関東
                            </div>
                            <br>
                            <p style="color:#6B4EFF;font-size:12px;">ユリさん・女性20代 M 関東</p>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaを始めたキッカケ</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                私はもともとLunaがリリースする前の開発段階から知っていたんです。<br />
                                SM自体は4-5年前に軽く首絞めをされて、そこで「首絞めって興奮するんだな」ってなり若干興味を持ち始めました。<br />
                                ただ興味は持っていたけれど、少し首絞めをされたくらいでして、SMの経験が豊富とは言えず、その時はまだ私にLunaは早いかなと思って少し遠慮をして離れていたんですよ。<br />
                                そうしたら、しばらく経ったある日、漫画家の音海ちさ先生の「Mは真面目のMなので」というBL系SM漫画を読むことがあり、<b>「やっぱりSMって楽しそう！」</b>ってなり、それで再熱してしまいました。<br />
                                漫画の内容はSMバーの話なのですが、SMプレイをしている描写もかなりありまして、「めっちゃくちゃいいなぁ」って思って、それでプレイをされてみたくなったんです。<br />
                                そして、漫画キッカケでSMをやりたくなり、Lunaのことを思い出し登録したのがキッカケでした。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaは始めた頃どんな印象でしたか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                第一印象はSM未経験なのに私なんかについていけるかなと思っていました。<br />
                                でも興味が勝って、「登録するだけ登録してダメだったらそのまま放置しちゃおう」って気軽に思って登録しました。<br />
                                そしたら意外にも沢山のいいね！が届いて、そしてメッセージでやり取りも始めて、思ったよりも楽しくなって放置はせずに続いていく形になっちゃいました。<br />
                                実際にLunaでは色んな人とマッチしました。ただ、実際に会うとなったのは今のパートナーさんが初めてでした。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>お相手とやり取りをしていてお相手はどのような印象でしたか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                なぜ会おうと思ったのかというと、明確に覚えてまして、他の方は短文で、ちょっとした簡単な挨拶などで終わっていた中、今のパートナーさんだけはSMをあまり知らない私に対して、私のツイートをしっかりと読み込んでくれた上で、ツイートから私が心の中でしたいと思っているような内容を長文で文字におこしてくれました。<br />
                                それがまるで自分の心の中が見透かされているかようので、とても心地よいと感じ、この人なら会いたい、と思ったのが理由でした。<br />
                                そのため、会おうという話になったのは、マッチをしてから１週間くらいでとてもスピード感がある形になりました。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>会ったときのお相手の印象</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                初めて会ったときは、私がSMどころか性経験もあまりあったほうではなかったので、怖いというよりも、緊張でドキドキでした。<br />
                                最初は気軽にカフェに行って、軽くお茶してSMについて色々教えてもらいました。<br />
                                しかも私に合わせるように丁寧にお話をしてくださって、「性癖の瓶の図」ってあると思うのですが、それを使い、「自分ができそうなことを一つ一つ知っていこうね」と言って、二人で一個ずつ何が出来るのかを確認をしていきました。<br />
                                そうしてくださったことで、私が全く何をすればいいのかわからなかったところから、何から試していこうかという話に繋がり、そして何が好きなのか、何がNGなのかなども出すことが出来、安心して一緒に進めていくことができました。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>現在はどのようなご関係なんですか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                パートナーという関係になります。<br />
                                お休みの日は、なるべく会うようにしてて、週１~２回は会ってますね！<br />
                                SMだけではなく、たまに普通に遊びに行ったりもしてて、素敵な時間を過ごしています。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaを使われる方へ一言</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <b>「私はLunaに出会って人生が大きく変わりました」</b><br />
                                もともと引きこもりがちだったのですが、Lunaでパートナーさんに出会い、外に出る機会が増えたことで、今では仕事も出来るようになり、人生が大きく変わり、本当にLunaには感謝をしています。<br />
                                SM初心者だとSMやLunaって怖いと思ってる人も多いと思うのですが、Lunaって経験者もいれば、初心者の人もいるので、SMに興味がある人でれば、最初に触れるキッカケにはとてもいいのではないでしょうか。<br />
                                特に初めての人は、しっかりとやり取りをして、 ① お互いの好きなことやNGなことがだいたい一緒かどうか、そして、 ②
                                話していて楽しいかどうか、の２つを確認するのが大事だと思います。<br />
                                一緒にいて苦痛になると大変なので、そうならない人を探すのがとっても大事です！<br />
                                頑張ってください！<br />
                                <br />
                                <img src="/images/Group13344.png" class="img-fluid">
                            </div>
                            <br>
                            <br>
                            <br>
                            <div style="border-radius: 6px;border: 1px solid #D9D9D9;padding:10px 0;" onclick="window.location.href = '/report/page5'">
                                <div class="row d-flex align-items-center">
                                    <div class="col-2 px-0" style="">
                                    </div>
                                    <div class="col-2 px-0">
                                        <img src="/images/Group13345_2.png" class="img-fluid">
                                    </div>
                                    <div class="col">
                                        <div style="font-size:10px;color#999">次のレポート</div>
                                        <div style="font-size:12px;">SMの話はしなかったのに…自然と惹かれ合い、パートナーへ。</div>
                                    </div>
                                    <div class="col-2 px-0 text-center">
                                        <svg style="height:14px;width:9px;fill:#E6E6E6;">
                                            <use xlink:href="/images/>.svg#page_right"></use>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div style="border-radius: 6px;border: 1px solid #D9D9D9;padding:10px 0;" onclick="window.location.href = '/report/page2'">
                                <div class="row d-flex align-items-center">
                                    <div class="col-2 px-0 text-center" style="">
                                        <svg style="height:14px;width:9px;fill:#E6E6E6;">
                                            <use xlink:href="/images/<.svg#page_left"></use>
                                        </svg>
                                    </div>
                                    <div class="col-2 px-0">
                                        <img src="/images/Group13341.png" class="img-fluid">
                                    </div>
                                    <div class="col">
                                        <div style="font-size:10px;color#999">前のレポート</div>
                                        <div style="font-size:12px;">1年も経たずに良い従者に出会え、とても幸せです！</div>
                                    </div>
                                    <div class="col-2 px-0">
                                    </div>
                                </div>
                            </div>
                            <br>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import HeaderMenu from './../HeaderMenu.vue'
import Footer from './../FooterLogin.vue'

export default {
    data() {
        return {
        };
    },
    components: {
        HeaderMenu: HeaderMenu,
        Footer: Footer,
    }
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=MuseoModerno:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Alegreya+Sans+SC:wght@700&display=swap');

a {
    color: #6B4EFF;
    text-decoration:none;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}


.item {
    float: left;
}

.logo {
    font-size: 30px;
    line-height: 30px;
    padding-top: 5px;
    padding-left: 5px;
}

.login-box {
    width: 100%;
    border-radius: 20px;
    background-color: #fff;
    padding: 25px;
}

.item_box {
    padding: 30px 25px;
    background: #FFFFFF;
    border-radius: 10px;
}
</style>
